import {useState, useRef} from 'react';
import {useDispatch} from 'react-redux';
import DepositBonus from '../../../../components/deposit_bonus';
import {setBitcoinProfit, setModalAlert} from '../../../../../reducers/app/actions';

const validate = data => {
    if(data.cashtag.length < 3)
        return false;

    return true;
}

export default ({onNext, setMethod, button}) => {
    const input = useRef(),
          dispatch = useDispatch();

    const [data, setData] = useState({
        cashtag: "",
        amount: 20
    });

    const validate_result = validate(data);

    const updateAmount = value => {
        if(input.current)
            input.current.value = value;

        return setData({
            ...data,
            amount: value
        });
    }

    const cashtagChangeHandler = e => {
        let value = e.target.value;

        if(value[0] == '$') {
            value = value.substr(1);
            e.target.value = value;
        }

        setData({
            ...data,
            cashtag: value
        });

        e.target.focus();
    }

    return (
        <>
            <div className="page-title">CashApp</div>
            <div className="page-descriptions">Enter your <b>$cashtag</b> and select the desired deposit amount</div>

            <div className="note" onClick={e => setMethod('bitcoin')}>
                <div className="note-body">
                    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.9775 8H2.97754V14C2.97754 16.25 3.72754 17 5.97754 17H11.9775C14.2275 17 14.9775 16.25 14.9775 14V8Z" stroke="#A8D81A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16.125 5.75V6.5C16.125 7.325 15.7275 8 14.625 8H3.375C2.2275 8 1.875 7.325 1.875 6.5V5.75C1.875 4.925 2.2275 4.25 3.375 4.25H14.625C15.7275 4.25 16.125 4.925 16.125 5.75Z" stroke="#A8D81A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8.73008 4.24996H4.59008C4.33508 3.97246 4.34258 3.54496 4.61258 3.27496L5.67758 2.20996C5.95508 1.93246 6.41258 1.93246 6.69008 2.20996L8.73008 4.24996Z" stroke="#A8D81A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.4025 4.24996H9.26245L11.3025 2.20996C11.58 1.93246 12.0375 1.93246 12.315 2.20996L13.38 3.27496C13.65 3.54496 13.6575 3.97246 13.4025 4.24996Z" stroke="#A8D81A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6.70508 8V11.855C6.70508 12.455 7.36508 12.8075 7.86758 12.485L8.57258 12.02C8.82758 11.855 9.15008 11.855 9.39758 12.02L10.0651 12.47C10.5601 12.8 11.2276 12.4475 11.2276 11.8475V8H6.70508Z" stroke="#A8D81A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                    Try to use <b>Bitcoin</b> to get <b>+ 15%</b>
                </div>

                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.8999 8.05999C9.2099 4.45999 11.0599 2.98999 15.1099 2.98999H15.2399C19.7099 2.98999 21.4999 4.77999 21.4999 9.24999V15.77C21.4999 20.24 19.7099 22.03 15.2399 22.03H15.1099C11.0899 22.03 9.2399 20.58 8.9099 17.04" stroke="#727272" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2 12.5H14.88" stroke="#727272" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12.6499 9.15002L15.9999 12.5L12.6499 15.85" stroke="#727272" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>

            <form onSubmit={e => {
                e.preventDefault();

                if(button)
                    return;

                if(!validate_result)
                    return dispatch(setModalAlert({
                        type: "danger",
                        title: "CashApp",
                        text: `Enter your <b>$cashtag</b>`,
                        button: "Got it!"
                    }));
                    // return window.alert(`Enter your $cashtag`);

                // if(data.amount < 20)
                //     return dispatch(setModalAlert({
                //         type: "danger",
                //         title: "CashApp",
                //         text: `Minimal deposit amount is <b>$20</b><br/>Use your <b>Cash Card</b> to deposit lower amount`,
                //         button: "Got it!"
                //     }));

                if(data.amount > 80)
                    return dispatch(setModalAlert({
                        type: "danger",
                        title: "CashApp",
                        text: `You can deposit no more than <b>$80</b> per transaction!<br/>If you want to make a deposit for a large amount, <b>divide it into several transactions</b>.`,
                        button: "Got it!"
                    }));
                
                // if(data.amount > 300)

                // if(data.amount > 80)
                //     return dispatch(setBitcoinProfit({
                //         method: "cashapp",
                //         amount: data.amount,
                //         onClick: e => setMethod('bitcoin'),
                //         onCancel: e => onNext(data)
                //     }));


                return onNext(data);
            }}>
                <div className="cashapp_sender">
                    <div className="sender">
                        <div className="symbol">$</div>
                        <input type="text" placeholder={"cashtag"} onInput={e => cashtagChangeHandler(e)} required />
                    </div>
                    <div className="label">Enter your cashtag</div>
                </div>

                <div className="amount_input cashapp" onClick={e => {
                    if(input.current)
                        input.current.focus();
                }}>
                    <div className="amount">
                        <div className="symbol">$</div>
                        <input type="tel" className="value" defaultValue={data.amount} placeholder="100.00" ref={input} required onInput={e => {
                            let value = e.target.value.toString().replace(/[^0-9]/gi, '.'),
                                cleared_value = "";

                            for(let i = 0; i < value.length; i++)
                                if(value[i] === '.' && i !== value.indexOf('.')) {

                                } else if(value.indexOf('.') >= 0 && i > value.indexOf('.') + 2) {

                                } else {
                                    cleared_value += value[i];
                                }

                            if(cleared_value[0] === '.')
                                cleared_value = `0${cleared_value}`;


                            updateAmount(cleared_value);
                        }} />

                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.2633 5.43908L5.05327 14.1291C4.74327 14.4591 4.44327 15.1091 4.38327 15.5591L4.01327 18.7991C3.88327 19.9691 4.72327 20.7691 5.88327 20.5691L9.10327 20.0191C9.55327 19.9391 10.1833 19.6091 10.4933 19.2691L18.7033 10.5791C20.1233 9.07908 20.7633 7.36908 18.5533 5.27908C16.3533 3.20908 14.6833 3.93908 13.2633 5.43908Z" stroke="#475A0E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M11.8931 6.88916C12.3231 9.64916 14.5631 11.7592 17.3431 12.0392" stroke="#475A0E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div className="label">Click to enter amount</div>
                </div>

                <div className="amount_buttons">
                    <div className={`amount_button ${data.amount == 20 ? 'active' : ''}`} onClick={() => updateAmount(20)}>$20</div>
                    <div className={`amount_button ${data.amount == 40 ? 'active' : ''}`} onClick={() => updateAmount(40)}>$40</div>
                    <div className={`amount_button ${data.amount == 60 ? 'active' : ''}`} onClick={() => updateAmount(60)}>$60</div>
                    <div className={`amount_button ${data.amount == 80 ? 'active' : ''}`} onClick={() => updateAmount(80)}>$80</div>
                    {/* <div className={`amount_button ${data.amount == 150 ? 'active' : ''}`} onClick={() => updateAmount(150)}>$150</div> */}
                    {/* <div className={`amount_button ${data.amount == 150 ? 'active' : ''}`} onClick={() => updateAmount(150)}>$150</div>
                    <div className={`amount_button ${data.amount == 200 ? 'active' : ''}`} onClick={() => updateAmount(200)}>$200</div>
                    <div className={`amount_button ${data.amount == 300 ? 'active' : ''}`} onClick={() => updateAmount(300)}>$300</div> */}
                </div>

               <DepositBonus points={[
                    {
                        amount: 20,
                        bonus: 5
                    }
                ]} amount={data.amount} defaultPercent={0} />

                {/* <DepositBonus points={[
                    {
                        amount: 100,
                        bonus: 10
                    },
                    {
                        amount: 200,
                        bonus: 15
                    }
                ]} amount={data.amount} defaultPercent={5} /> */}

                {/* <div className="button green">Open CashApp for payment</div> */}
                <button className="button blue" type="submit" style={{
                    opacity: (validate_result && !button) ? 1 : 0.7,
                    cursor: !button ? 'pointer' : 'no-drop',
                }}>{!button ? 'Next' : 'Please wait..'}</button>
            </form>
        </>
    )
}